import { render, staticRenderFns } from "./IconSuccess.vue?vue&type=template&id=2764e0b7&"
import script from "./IconSuccess.vue?vue&type=script&lang=js&"
export * from "./IconSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports